<template>
  <div style="height: 100%;">
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from '../../echarts/bar.vue'
export default {
  data() {
    return {
      cdata: {
        category: [
            "芨芨草型"
            ,
            "西北针茅、早熟禾型"
            ,
            "苔草、杂类草型"
            ,
            "羊草、杂类草型"
        ],
        lineData: [
            264.78,
            67795.63,
            21298.37,
            10366.94,
        ],
        title: "草原型",
        yAxisUnit:"万亩",
        rateData: []
      }
    };
  },
  components: {
    Chart,
  },
  mounted() {
    this.setData();
  },
  methods: {
    // 根据自己的业务情况修改
    setData() {

    },
  }
};
</script>

<style lang="scss" scoped></style>